'use strict';

var index = require('./themes/index.js');
var utils = require('./themes/utils.js');

var metadata = utils.resolveMetaThemeRefs(index.metaThemeDefault);
/**
 * Identity function that simply returns the provided tokens with metadata, but additionally
 * validates the input matches the `Metadata` type exactly and infers all members.
 */
function createMetadata(metadata) {
  return metadata;
}

exports.createMetadata = createMetadata;
exports.metadata = metadata;
